export enum UserInspectionActionType {
  SET_USER_INSPECTION = 'SET_USER_INSPECTION',
  UPDATE_USER_INSPECTION = 'UPDATE_USER_INSPECTION',
}
